export default "__VITE_PUBLIC_ASSET__0dc20903__"